"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semantic_ui_react_8 = require("semantic-ui-react");
exports.default = function (props) {
    return React.createElement(semantic_ui_react_8.Card, null, React.createElement(semantic_ui_react_8.Card.Content, null, React.createElement(semantic_ui_react_8.Card.Header, null, "Tags")), React.createElement(semantic_ui_react_8.Card.Content, null, React.createElement(semantic_ui_react_8.List, null, props.tags.map(function (tag) {
        var isActive = tag.fieldValue === props.tag;
        var activeStyle = {
            fontWeight: "700"
        };
        return React.createElement(semantic_ui_react_8.List.Item, { as: "a", key: tag.fieldValue }, React.createElement(semantic_ui_react_8.List.Icon, { name: "tag", color: isActive ? "blue" : null }), React.createElement(semantic_ui_react_8.List.Content, { style: isActive ? activeStyle : null }, React.createElement(props.Link, { to: "/blog/tags/" + tag.fieldValue + "/" }, tag.fieldValue, " (", tag.totalCount, ")")));
    }))));
};


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/components/TagsCard/TagsCard.tsx